<template>
  <div>
    <IconBase :name="name" :width="width" @mouseenter.native="isHover = true" @mouseleave.native="isHover = false" />

    <TooltipBase :is-active="isHover" classes="bg-charcoal-950 bg-opacity-60 py-2 px-4 rounded-md text-white text-xs m-2 font-medium">
      {{ content }}
    </TooltipBase>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(defineProps<{
  content?: string
  name?: string
  width?: number
}>(), {
  content: '',
  name: 'lock',
  width: 18
})

const isHover = ref(false)
</script>